import { HttpClientAuthenticationProvider } from "./HttpClientAuthenticationProvider";

export type AuthenticationMode = "browser-credentials-include" | { authSid: string };

const includeCredentialsAuthenticationProvider: HttpClientAuthenticationProvider = request => {
    request.credentials = "include";
    return request;
};

const omitCredentialsAuthenticationProvider: HttpClientAuthenticationProvider = request => {
    request.credentials = "omit";
    return request;
};

const passAuthSidIntoHeaderAuthenticationProvider =
    (sid: string): HttpClientAuthenticationProvider =>
    request => {
        request.credentials = "omit";
        request.headers = {
            ...request.headers,
            Authorization: `AUTH.SID ${sid}`,
        };
        return request;
    };

export function createAuthenticationProvider(
    authentication: AuthenticationMode | undefined
): HttpClientAuthenticationProvider {
    if (authentication == undefined || authentication === "browser-credentials-include") {
        return includeCredentialsAuthenticationProvider;
    } else if ("authSid" in authentication && authentication.authSid != undefined) {
        return passAuthSidIntoHeaderAuthenticationProvider(authentication.authSid);
    }
    return omitCredentialsAuthenticationProvider;
}
